<template>
  <div class="px-2 py-1 text-gray-700">Due: {{ dueAt }}</div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'KanbanBoardTaskListLineDue',
  props: {
    task: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dueAt() {
      if (!this.task.dueAt) {
        return 'no due';
      }

      const dueDate = moment(this.task.dueAt);

      return moment().isBefore(dueDate) ? moment().to(dueDate) : dueDate.from(moment());
    },
  },
};
</script>
